<template>
  <w-icon-wrapper
    icon-name="work-global-search"
    :width="27"
    :height="24"
    view-box="0 0 27 24"
  >
    <g>
      <path
        d="M15.2369 0C10.7158 0 6.8008 2.62605 4.92505 6.43527C5.23286 6.3968 5.5503 6.37756 5.86773 6.37756C6.28136 6.37756 6.69499 6.41603 7.08938 6.48337C8.38798 4.40561 10.4561 2.8473 12.8898 2.23166C11.6681 3.88617 10.7832 5.74269 10.2541 7.71463C10.8601 8.12826 11.4084 8.61884 11.8798 9.17676C12.3703 6.65652 13.5054 4.30942 15.2273 2.36633C17.2665 4.66533 18.4978 7.53187 18.7864 10.5523H12.8224C13.1399 11.1487 13.3804 11.7932 13.5439 12.4762H18.7768C18.5074 15.208 17.4878 17.7764 15.8237 19.9215L18.4497 22.5475C23.2305 21.1431 26.7319 16.7279 26.7319 11.5046C26.7511 5.16553 21.5856 0 15.2369 0ZM17.5744 2.22204C21.4317 3.19359 24.3655 6.50261 24.7695 10.5427H20.7198C20.4601 7.51263 19.3635 4.64609 17.5744 2.22204ZM17.5744 20.7968C19.3539 18.3824 20.4505 15.5255 20.7198 12.4762H24.7695C24.3655 16.5259 21.4317 19.8253 17.5744 20.7968Z"
        fill="currentColor" 
      />
      <path
        d="M14.2365 23.9904L15.5639 22.6629L11.1198 18.2188H10.4176L10.1675 17.9784C11.0429 16.9683 11.5623 15.6505 11.5623 14.2172C11.5623 11.0236 8.97475 8.43607 5.78117 8.43607C2.58758 8.43607 0 11.0236 0 14.2172C0 17.4108 2.58758 19.9984 5.78117 19.9984C7.21443 19.9984 8.53227 19.4693 9.54229 18.6036L9.78277 18.8537V19.5559L14.2269 24M5.78117 10.2156C7.99359 10.2156 9.78277 12.0048 9.78277 14.2172C9.78277 16.4297 7.99359 18.2188 5.78117 18.2188C3.56874 18.2188 1.77956 16.4297 1.77956 14.2172C1.77956 12.0048 3.56874 10.2156 5.78117 10.2156Z"
        fill="currentColor" 
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconGlobalSearch' };
</script>